import axios from "@/utils/axios";

enum Api {
  info = "/wxapi/wechat/getInfo",
  bind = "/wxapi/wechat/bind",
  code = "/wxapi/wechat/sendCode",
  log = "/wxapi/wechat/consume/recordList",
  queryLimit = "/wxapi/wechat/consume/consumeLimitInfo",
  saveLimit = "/wxapi/wechat/consume/saveConsumeLimit",
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace My {
  export interface infoResObj {
    companyId: number;
    companyName: string;
    userId: number;
    personId: number;
    jobNum: string;
    name: string;
    phone: string;
    deptName: string;
    cardNo: null;
    photoPath: string;
    amount: number;
  }
  export interface CodeReqForm {
    jobNum: string;
    name: string;
    phone: string;
  }
  export interface BindReqForm {
    jobNum: string;
    name: string;
    phone: string;
    code: string;
  }
  // export interface SaveLimitForm {

  // }
  export interface getListParams {
    pageNum: number;
    pageSize: number;
  }
}

// 获取用户信息
export const getInfo = () => {
  return axios.get<My.infoResObj>(Api.info);
};

// 用户信息绑定
export const bind = (params: My.BindReqForm) => {
  return axios.post(Api.bind, params);
};

// 发送验证码
export const sendCode = (params: My.CodeReqForm) => {
  return axios.post(Api.code, params);
};

// 交易记录
export const getConsumeLog = (params: My.getListParams) => {
  return axios.get(Api.log, params);
};

// 查询消费限制
export const getLimit = () => {
  return axios.get(Api.queryLimit);
};

// 保存消费限制
export const saveLimit = (params: any) => {
  return axios.post(Api.saveLimit, params);
};
